import { HEROS_SERVICE } from "@/services/heros.service.js";

const state = {postHeroOutput: false, getHerosOutput: {}, putHerosOutput: false, getHeroByIdOutput: {}, deleteHeroByIdOutput: false, putHerosStatusIdOutput: false};

const actions = {
    //Service to create hero content
    postHero({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postHeroRequest');

        HEROS_SERVICE.postHero(input)
            .then(
                output => {
                    commit('postHeroSuccess', output);
                },
                error => {
                    commit('postHeroFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated hero content
    getHeros({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getHerosRequest');

        HEROS_SERVICE.getHeros(queryParams)
            .then(
                output => {
                    commit('getHerosSuccess', output);
                },
                error => {
                    commit('getHerosFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update hero content
    putHero({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putHerosRequest');

        HEROS_SERVICE.putHero(input)
            .then(
                output => {
                    commit('putHerosSuccess', output);
                },
                error => {
                    commit('putHerosFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get hero details.
    getHeroById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getHeroByIdRequest');

        HEROS_SERVICE.getHeroById(id)
            .then(
                output => {
                    commit('getHeroByIdSuccess', output);
                },
                error => {
                    commit('getHeroByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete heros
    deleteHeroById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteHeroByIdRequest');

        HEROS_SERVICE.deleteHeroById(id)
            .then(
                output => {
                    commit('deleteHeroByIdSuccess', output);
                },
                error => {
                    commit('deleteHeroByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to change hero status
    putHeroStatusById({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('putHerosStatusIdRequest');

        HEROS_SERVICE.putHeroStatusById(queryParams)
            .then(
                output => {
                    commit('putHerosStatusIdSuccess', output);
                },
                error => {
                    commit('putHerosStatusIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postHero
    postHeroRequest(state) {
        state.postHeroOutput = null;
    },
    postHeroSuccess(state, output) {
        state.postHeroOutput = true;
    },
    postHeroFailure(state) {
        state.postHeroOutput = false;
    },

    //getHeros
    getHerosRequest(state) {
    },
    getHerosSuccess(state, output) {
        state.getHerosOutput = output;
    },
    getHerosFailure(state) {
        state.getHerosOutput = false;
    },

    //putHero
    putHerosRequest(state) {
        state.putHerosOutput = null;
    },
    putHerosSuccess(state, output) {
        state.putHerosOutput = true;
    },
    putHerosFailure(state) {
        state.putHerosOutput = false;
    },

    //getHeroById
    getHeroByIdRequest(state) {
    },
    getHeroByIdSuccess(state, output) {
        state.getHeroByIdOutput = output;
    },
    getHeroByIdFailure(state) {
        state.getHeroByIdOutput = false;
    },

    //deleteHeroById
    deleteHeroByIdRequest(state) {
        state.deleteHeroByIdOutput = null;
    },
    deleteHeroByIdSuccess(state, output) {
        state.deleteHeroByIdOutput = true;
    },
    deleteHeroByIdFailure(state) {
        state.deleteHeroByIdOutput = false;
    },

    //putHeroStatusById
    putHerosStatusIdRequest(state) {
        state.putHerosStatusIdOutput = null;
    },
    putHerosStatusIdSuccess(state, output) {
        state.putHerosStatusIdOutput = true;
    },
    putHerosStatusIdFailure(state) {
        state.putHerosStatusIdOutput = false;
    },
};

export const heros = {
    namespaced: true,
    state,
    actions,
    mutations
};